<template>
  <keep-alive>
    <a-menu
      class="m-menu"
      theme="light"
      mode="inline"
      :selectedKeys="[current]"
    >
      <a-divider
        :dashed="true"
        class="m-small"
        orientation="left"
        v-if="getIsSpecialMenus.length > 0"
        >Special Menu</a-divider
      >
      <template v-if="getIsSpecialMenus !== undefined">
        <template v-for="menu in getIsSpecialMenus">
          <a-menu-item @click="handleMenu" :key="menu.id_menu">
            <router-link
              :to="{ name: menu.label_menu, params: { child: menu.child } }"
            >
              <a-icon :type="menu.icon_menu" />
              <span>{{ menu.label_menu }}</span>
            </router-link>
          </a-menu-item>
        </template>
      </template>
      <a-divider :dashed="true" class="m-small" orientation="left"
        >Menu Utama</a-divider
      >
      <template v-for="menu in getmenus_source.child">
        <a-menu-item
          @click="handleMenu"
          :key="menu.id_menu"
          v-if="menu.child.length <= 0"
        >
          <router-link
            :to="
              menu.link_menu === 'profile'
                ? { name: menu.link_menu, params: { tlc: getAuth.username } }
                : { name: menu.link_menu }
            "
          >
            <a-icon :type="menu.icon_menu" />
            <span>{{ menu.label_menu }}</span>
          </router-link>
        </a-menu-item>
        <a-sub-menu :key="menu.id_menu" v-else>
          <span slot="title">
            <a-icon :type="menu.icon_menu" />
            <span>{{ menu.label_menu }}</span>
          </span>
          <a-menu-item
            v-for="childmenu in menu.child"
            :key="childmenu.id_menu"
            @click="handleMenu"
          >
            <router-link :to="{ name: childmenu.link_menu }">
              <a-icon :type="childmenu.icon_menu" />
              <span>{{ childmenu.label_menu }}</span>
            </router-link>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </keep-alive>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "Menu",
  data() {
    return {
      current: ""
    };
  },
  created() {},
  computed: {
    ...mapGetters(["getAuth", "getMenus", "getIsSpecialMenus"]),
    getmenus_source() {
      let tresult = this.getMenus;
      if(tresult.child)
        for (let i = 0; i < tresult.child.length; i++) {
          for (let i2 = 0; i2 < tresult.child[i].child.length; i2++) {
            if (tresult.child[i].child[i2].link_menu == 'absenPhoto' && !this.isMobile) {
              let temp = tresult.child[i].child[i2];
              temp = _.filter(tresult.child[i].child, (item) => item.link_menu != 'absenPhoto')
              tresult.child[i].child = temp;
            }
          }
        }
      return tresult;
    }
  },
  methods: {
    handleMenu(e) {
      this.current = e.key;
      localStorage.setItem("mns_", e.key);
      Event.$emit("drawerNav");
    }
  }
};
</script>

<style></style>
